export type ChordEvent = Pick<KeyboardEvent, 'key' | 'ctrlKey' | 'metaKey' | 'altKey' | 'shiftKey'>;

/**
 * Forma canónica `mod+shift+alt+tecla` para que un atajo se escriba igual en el registro
 * y se compare igual venga de donde venga. `mod` unifica Ctrl y Cmd: el mismo mapa sirve
 * en Linux y en macOS.
 */
export const chordFromEvent = (event: ChordEvent): string => {
  const parts: string[] = [];
  if (event.ctrlKey || event.metaKey) parts.push('mod');
  // Shift solo cuenta como modificador si la tecla no es ya el símbolo que produce.
  if (event.shiftKey && event.key.length > 1) parts.push('shift');
  if (event.altKey) parts.push('alt');
  parts.push(normalizeKey(event.key));
  return parts.join('+');
};

/** Un acorde sin modificadores: `a`, `j`, `?`. Los que se filtran al escribir en un input. */
export const isBareChord = (chord: string): boolean => !chord.includes('+');

const normalizeKey = (key: string): string => {
  if (key === ' ') return 'space';
  if (key === 'Escape') return 'escape';
  if (key === 'Enter') return 'enter';
  if (key.startsWith('Arrow')) return key.slice(5).toLowerCase();
  return key.length === 1 ? key.toLowerCase() : key.toLowerCase();
};

const SYMBOLS: Record<string, string> = {
  mod: navigatorIsApple() ? '⌘' : 'Ctrl',
  shift: '⇧',
  alt: 'Alt',
};

/** Etiqueta legible para la paleta y la ayuda de atajos. */
export const formatChord = (chord: string): string =>
  chord
    .split('+')
    .map((part) => SYMBOLS[part] ?? (part.length === 1 ? part.toUpperCase() : part))
    .join(navigatorIsApple() ? '' : '+');

function navigatorIsApple(): boolean {
  return /mac|iphone|ipad/i.test(globalThis.navigator?.platform ?? '');
}
